import {version} from './../../package.json';

export const IDLE_TIMEOUT = 900000 * 100//15 min
//export const IDLE_TIMEOUT = 15000 //15 sec
export const APP_VERSION = version
export const NULL_UID = '00000000-0000-0000-0000-000000000000'